import { render, staticRenderFns } from "./UpToStandardChart.vue?vue&type=template&id=43501004"
import script from "./UpToStandardChart.vue?vue&type=script&lang=js"
export * from "./UpToStandardChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports